<template>
    <div>
        <Navbar v-if="this.$route.name=='examcorrectiondetailsel'"/>
        <Breadcrumb v-if="this.$route.name=='examcorrectiondetailsel'" /> 
        <div class="pl-3">
            Correcting {{ exam.exam_name }} for {{ `${consultant.id} ${consultant.family_name}, ${consultant.first_name }` }}
        </div>
        <b-row>
            <b-col>
                <b-card class="my-3">
                    <template #header>
                        <b-row>
                            <b-col cols="6">
                                <h6 class="mt-0 mb-0">Exam Questions</h6>
                            </b-col>
                            <b-col class="text-right" cols="6">
                                <b-button
                                    @click.prevent="resetCourse"
                                    variant="secondary"
                                >
                                    Cancel
                                </b-button>
                                <b-button
                                    @click.prevent="save_corrections"
                                    class="ml-3"
                                    variant="primary"
                                >
                                    Save
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                    <b-table striped hover :items="examanswers" :fields="examanswerscolumns">
                        <template v-slot:cell(answer_correct)="data">
                            <b-form-checkbox v-model="correctStates[data.item.id]"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button size="sm" @click="openCommentsModal(data.item.id)">Comments</b-button>
                        </template>
                        <!-- <template v-slot:cell(teacher_comment)="data">
                            <b-form-input v-model="teacherComments[data.item.id]"/>
                        </template> -->
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
        <b-modal
            v-model="showcomms"
            title="Comments"
            size="xl"
            @close="closeCommentsModal"
        >
            <ExamNotes :examanswerId="communicationid"/>
        </b-modal>
    </div>
</template>
<script>
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import ExamNotes from './ExamNotes.vue';

export default {
    name: 'ExamCorrectionDetail',
    components: {
        Navbar,
        Breadcrumb,
        ExamNotes
    },
    props: {
        courseId: {
            type: [String, Number],
            default: ''
        },
        examId: {
            type: [String, Number],
            default: ''
        },
        consultantId: {
            type: [String, Number],
            default: ''
        },
        resetCourse: {
            type: Function,
            required: true
        }
    },
    computed:{
        course_id() {
            if (this.courseId !== '') {
                return this.courseId;
            }
            return this.$route.params.courseId;
        },
        exam_id() {
            let res = null;
            if (this.examId !== '') {
                res = this.examId;
            } else {
                res = this.$route.params.examId;
            }
            return res;
        },
        consultant_id() {
            if (this.consultantId !== '') {
                return this.consultantId;
            }
            return this.$route.params.consultantId;
        }
    },
    data() {
        return {
            exam: {},
            examanswers: [],
            examanswerscolumns: [
                { key: 'id', label: 'ID', sortable: false, thClass: 'd-none', tdClass: 'd-none' },
                { key: 'examquestion_id', label: '#', sortable: true, thClass: 'gdq-w-5', tdClass: 'gdq-w-5' },
                { key: 'question_id', label: 'Question', sortable: false, thClass: 'gdq-w-40', tdClass: 'gdq-w-40' },
                { key: 'answer', label: 'Answer', sortable: false, thClass: 'gdq-w-40', tdClass: 'gdq-w-40' },
                { key: 'answer_correct', label: 'Correct', sortable: true, thClass: 'gdq-w-5', tdClass: 'gdq-w-5' },
                // { key: 'teacher_comment', label: 'Teacher comment', sortable: false, thClass: 'gdq-w-25', tdClass: 'gdq-w-25' },
                { key: 'actions', label: '', sortable: false, thClass: 'gdq-w-10', tdClass: 'gdq-w-10' },
            ],
            consultant: {},
            questions: [],
            examquestions: [],
            correctStates: {},
            teacherComments: {},
            communicationid: 0,
            showcomms: false,
        }
    },
    async created() {
        await this.exam_get();
        this.consultant_get();
        await this.examquestions_get().then (() => {
            this.consultant_answers_get();
        });
    },
    methods: {
        openCommentsModal(id) {
            this.communicationid = id;
            this.showcomms = true;
        },
        closeCommentsModal() {
            this.communicationid = 0;
            this.showcomms = false;
        },
        async save_corrections() {
            for (let i=0;i<this.examanswers.length; i++) {
                const correctAnswer = this.correctStates[this.examanswers[i].id]
                // Save corrent/incorrent
                const rec = {
                    id: this.examanswers[i].id,
                    answer_correct: correctAnswer ? 1 : 0,
                }
                await this.$store.dispatch('record_put', { table_name: 'g_elearning_consultant_exam_answers', id: rec.id, record: rec })
                // TODO Save teacher comment
                const commentrec = {
                    examanswer_id: this.examanswers[i].id,
                    examanswer_comment:
                        this.teacherComments[this.examanswers[i].id] ?
                        this.teacherComments[this.examanswers[i].id] :
                        ''
                }
                await this.$store.dispatch(
                    'record_post',
                    {
                        table_name: 'g_elearning_consultant_exam_answer_notes',
                        record: commentrec
                    }
                )
            }
            this.resetCourse();
        },
        async exam_get() {
            this.$store.dispatch('record_read', {
                table_name: 'g_elearning_exams',
                id: this.exam_id
            })
            .then((resp) => {
                this.exam = resp.data;
            })
        },
        consultant_get() {
            this.$store.dispatch('record_read', {
                table_name: 'i_user',
                id: this.consultant_id
            })
            .then((resp) => {
                this.consultant = resp.data;
            })
        },
        async examquestions_get() {
            const filter = {
                exam_id: {
                    value: this.exam_id,
                    operator: '='
                }
            }
            let examquestions = await this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_exams_questions',
                filter,

            }).then(r => r.data.result);
            for (let i = 0; i < examquestions.length; i++) {
                const answeroptions = await this.$store.dispatch('records_readall', {
                    table_name: 'g_elearning_question_options',
                    page: 1,
                    perPage: 1000
                }).then(r => {
                    return r.data.result
                })
                const thisoptions = answeroptions.filter(o => o.question_id.toString() === examquestions[i]._question_id.toString())
                examquestions[i].options = thisoptions;
            }
            this.examquestions = examquestions;
        },
        async consultant_answers_get() {
            const filter = {
                course_id: {
                    value: this.course_id,
                    operator: '='
                },
                exam_id: {
                    value: this.exam_id,
                    operator: '='
                },
                consultant_id: {
                    value: this.consultant_id,
                    operator: '='
                }
            }
            await this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_consultant_exam_answers',
                filter,
                page: 1,
                perPage: 1000
            })
            .then((resp) => {
                // All answers
                let examanswers = resp.data.result.map(a => {
                    return {
                        ...a,
                        teacher_comment: '',
                    }
                });
                for (let i = 0; i < examanswers.length; i++) {
                    // Find the question
                    const examquestion = this.examquestions.find(q => { 
                        return q._question_id.toString() === examanswers[i]._question_id.toString()
                    });
                    for (let j = 0; j < examquestion.options.length; j++) {
                        if (examquestion.options[j].questionoption_value.toString() === examanswers[i].answer.trim().toString()) {
                            examanswers[i].answer = examquestion.options[j].questionoption_text;
                        }
                    }
                    examanswers[i].answer_correct = examanswers[i].answer_correct === '1';
                    this.$store.dispatch('records_readlist',
                        {
                            table_name: 'g_elearning_consultant_exam_answer_notes',
                            filter: {
                                examanswer_id: {
                                    value: examanswers[i].id,
                                    operator: '='
                                }
                            }
                        }
                    ).then((commentsresult) => {
                        const comments = commentsresult.data.result
                        console.log({comments})
                        let comment = '';
                        for (let j=0; j<comments.length; j++) {
                            comment = comment + '\n' + comments[j].examanswer_comment
                        }
                        this.teacherComments[examanswers[i].id] = comment
                        examanswers[i].teacher_comment = comment
                    })
                    this.correctStates[examanswers[i].id] = examanswers[i].answer_correct
                }
                this.examanswers = examanswers;
            })
        }, 
    }   
}
</script>